const state = {
  appSettings: {},
  isSideNavCollapsed: false,
  toastOptions: {
    display: false,
    description: "Success",
    type: "success",
    title: "Success",
  },
};
export default state;
